@let showsSelected = challenge().isSelected || previewSelected();

<div
  class="card"
  [id]="challenge().offerId"
  [style.boxShadow]="config().boxShadow ? config().boxShadow : ''"
>
  <div
    class="card-header"
    role="img"
    [style]="{
      height: config().header.height,
      backgroundImage: config().header.backgroundImage.url | transformUrl,
    }"
    [title]="
      config().header.backgroundImage.bannerAriaLabel
        | replaceVars: challenge().target
    "
    [attr.aria-label]="
      config().header.backgroundImage.bannerAriaLabel
        | replaceVars: challenge().target
    "
  >
    <!-- Reward Ratio FairPrice -->
    @let headerRewardRatio = config().headerRewardRatio;
    @if (
      headerRewardRatio && challenge().isSelected && !challenge().isCompleted
    ) {
      <div
        class="header-reward"
        [style]="{
          backgroundColor: headerRewardRatio.backgroundColor,
          color: headerRewardRatio.color,
          fontFamily: headerRewardRatio.fontFamily,
        }"
      >
        <p class="collect-up-to">{{ headerRewardRatio.collectUpTo.text }}</p>
        <p
          class="reward"
          [innerHTML]="headerRewardPoints() | formatReward | safe"
        ></p>
        <p class="points">{{ headerRewardRatio.points.text }}</p>
      </div>
    }

    <!-- Header Title -->
    <div class="header-details">
      @let headerTitle = config().header.backgroundImage.title;
      @if (headerTitle) {
        <p
          class="title"
          [style]="{
            color: headerTitle.color,
            fontFamily: headerTitle.fontFamily,
          }"
          [innerHTML]="headerTitle.text"
        ></p>
      }

      <!-- Header Subtitle -->
      @let headerSubtitle = config().header.backgroundImage.subTitle;
      @if (headerSubtitle) {
        <p
          class="sub-title"
          [style]="{
            color: headerSubtitle.color,
            fontFamily: headerSubtitle.fontFamily,
          }"
          [innerHTML]="
            headerSubtitle.text | replaceVars: challenge().target | safe
          "
        ></p>
      }
    </div>
  </div>

  <!-- Card SubHeader -->
  <div
    class="card-subheader"
    [class.card-subheader-completed]="challenge().isCompleted"
    [style.backgroundColor]="
      challenge().isCompleted
        ? config().subHeader.completedBackgroundColor
        : config().subHeader.backgroundColor
    "
  >
    <!-- Subheader Title -->
    @let labelConfig = config().subHeader.title;
    @if (labelConfig) {
      <p
        class="label"
        [style]="{
          color: labelConfig.color,
          fontFamily: labelConfig.fontFamily,
        }"
      >
        {{
          labelConfig.label | replaceVars: challenge().minAmountByTransaction
        }}
      </p>
    }
    @let subHeaderImage = config().subHeader.picture;
    @if (subHeaderImage && !challenge().isCompleted) {
      <div class="icon">
        <b2c-icon
          b2cElement
          [icon]="subHeaderImage.imageUrl"
          [buttonTitle]="subHeaderImage.alternativeText"
          (click)="displayInfoDialog(phase(), challenge())"
          [disabled]="
            phase() !== CampaignPhase.CURRENT || challenge().isOutOfStock()
          "
        />
      </div>
    }
  </div>

  <div
    class="card-content"
    data-variant="variant_1"
    data-cy="frequency-card-content"
  >
    <!-- Win Card -->
    @if (challenge().isCompleted) {
      <b2c-win-card class="win-container" [amount]="challenge().rewardRatio" />
    }

    @if (showsSelected && challenge().progress < challenge().target) {
      <!-- Card Body -->
      <div class="card-body">
        @let bodyLabel = config().body.label;
        @if (bodyLabel) {
          <h6
            class="text-center mb-3 label"
            [style.fontFamily]="config().body.labelFontFamily"
            [style.fontSize]="config().body.labelFontSize"
            [innerHTML]="bodyLabel | replaceVars: challenge().target | safe"
          ></h6>
        }

        <!-- Steps < 5 -->
        @let steps = challenge().steps;
        @if (steps.length <= 5) {
          <div class="items" data-cy="stamps">
            @for (step of steps; track $index) {
              <div class="item">
                @let stamps = config().body.stamps;
                @if (stamps) {
                  <img
                    alt=""
                    data-cy="stamp"
                    class="responsive-width"
                    [src]="
                      step <= challenge().progress
                        ? stamps.iconSelected
                        : stamps.iconNonSelected
                    "
                  />
                  @if (stamps.showNumbers) {
                    <span
                      class="number"
                      aria-hidden="true"
                      [class.active]="step <= challenge().progress"
                    >
                      {{ step }}
                    </span>
                  }
                }
              </div>
            }
            @let bodyRewardRatio = config().body.rewardRatio;
            @if (bodyRewardRatio) {
              <div
                class="reward-ratio"
                [style]="{
                  color: bodyRewardRatio.color,
                  fontFamily: bodyRewardRatio.fontFamily,
                }"
              >
                <img
                  [alt]="
                    bodyRewardRatio.rewardPicture.alternativeText
                      | replaceVars: challenge().rewardRatio
                  "
                  [src]="bodyRewardRatio.rewardPicture.imageUrl"
                />
                <span> {{ challenge().rewardRatio }}€</span>
              </div>
            }
          </div>
        } @else {
          <div class="visits-container">
            <span class="number" data-cy="progress">{{
              challenge().progress
            }}</span>
            <span class="sign">/</span>
            <span class="number total" data-cy="target">{{
              challenge().target
            }}</span>
            @let bodyRewardRatio = config().body.rewardRatio;
            @if (bodyRewardRatio) {
              <div
                class="reward-ratio"
                [style]="{
                  color: bodyRewardRatio.color,
                  fontFamily: bodyRewardRatio.fontFamily,
                }"
              >
                <img
                  [alt]="
                    bodyRewardRatio.rewardPicture.alternativeText
                      | replaceVars: challenge().rewardRatio
                  "
                  [src]="bodyRewardRatio.rewardPicture.imageUrl"
                />
                <span> {{ challenge().rewardRatio }}€</span>
              </div>
            }
          </div>
        }
      </div>

      <!-- Card Footer -->
      @let remainingVisitsLabel = config().footer.remainingVisitsLabel;
      <div
        class="card-footer"
        [class.remaining-visits-footer]="remainingVisitsLabel"
      >
        <!-- Unselection Button. Keyed on the real selection, not the preview:
             there is nothing to unselect on a card still being swiped. -->
        @if (challenge().canBeUnselected(phase())) {
          <b2c-unselection-button
            [phase]="phase()"
            [challenge]="challenge()"
            class="unselect-challenge"
            [isBisCampaign]="isBisCampaign()"
            [isEventChallenge]="isEventChallenge()"
          />
        }

        @if (remainingVisitsLabel) {
          <p
            class="remaining-visits"
            [style]="{
              color: remainingVisitsLabel.color,
              fontFamily: remainingVisitsLabel.fontFamily,
            }"
            [innerHTML]="
              remainingVisitsLabel.text | replaceVars: remainingVisits() | safe
            "
          ></p>
        } @else {
          <div class="footer-box">
            @let footerIcon = config().footer.footerIcon;
            @if (footerIcon) {
              <span class="icon">
                <b2c-icon
                  [disabled]="true"
                  [icon]="footerIcon.imageUrl"
                  [buttonTitle]="footerIcon.alternativeText"
                />
              </span>
            }
            <p
              class="label"
              [style]="{
                color: config().footer.color,
                fontFamily: config().footer.fontFamily,
              }"
              [innerHTML]="config().footer.label | safe"
            ></p>
            <span
              class="visits-made"
              [style]="{
                color: config().footer.color,
                fontFamily: config().footer.fontFamily,
              }"
            >
              <div class="visits-progress">{{ challenge().progress }}</div>
              /
              <div class="visits-target">{{ challenge().target }}</div>
            </span>
          </div>
        }
      </div>
    }

    <!-- Selection Button -->
    @if (!showsSelected) {
      <div class="overlay">
        <b2c-selection-button
          b2cElement
          [phase]="phase()"
          [challenge]="challenge()"
          class="selection-button"
          [isBisCampaign]="isBisCampaign()"
          [isEventChallenge]="isEventChallenge()"
        />
      </div>
    }
  </div>
</div>
